import React from "react";
import Container from "@/components/marketing/Container";

const REGION_ORDER = ["UK", "US", "UAE", "GCC", "MENA", "Africa", "Global"];

function titleCase(s) {
  return s.replace(/\w\S*/g, (t) => t.charAt(0).toUpperCase() + t.slice(1).toLowerCase());
}

const FOCUS_OVERRIDES = { seo: "SEO" };

function Chip({ active, onClick, children }) {
  return (
    <button
      type="button"
      onClick={onClick}
      className={`px-4 py-1.5 rounded-full text-sm font-medium transition-colors border ${
        active
          ? "bg-cobalt text-white border-cobalt"
          : "bg-white text-steel border-border hover:border-cobalt/40 hover:text-bone"
      }`}
    >
      {children}
    </button>
  );
}

export default function PackagesFilterBar({
  availableRegions = [],
  availableFocuses = [],
  selectedRegion,
  selectedFocus,
  onRegionChange,
  onFocusChange,
}) {
  const regions = ["All", ...REGION_ORDER];
  const focuses = ["All", ...availableFocuses];

  return (
    <section className="bg-[#f7f7f9] pt-10 sm:pt-12 lg:pt-14 pb-2">
      <Container className="space-y-3">
        <div className="flex flex-wrap items-center gap-2">
          <span className="font-mono text-xs uppercase tracking-widest text-steel mr-2">Region</span>
          {regions.map((r) => (
            <Chip key={r} active={selectedRegion === r} onClick={() => onRegionChange(r)}>
              {r}
            </Chip>
          ))}
        </div>
        <div className="flex flex-wrap items-center gap-2">
          <span className="font-mono text-xs uppercase tracking-widest text-steel mr-2">Focus</span>
          {focuses.map((f) => (
            <Chip key={f} active={selectedFocus === f} onClick={() => onFocusChange(f)}>
              {f === "All" ? "All" : (FOCUS_OVERRIDES[f.toLowerCase()] || titleCase(f))}
            </Chip>
          ))}
        </div>
      </Container>
    </section>
  );
}